import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Pagination from '../../Pagination';
import { Table, Input } from 'semantic-ui-react';
import moment from 'moment';
import { printUrl } from '../../../helpers/policy';

class PolicyDocuments extends Component {
	constructor(props) {
		super(props);
		this.state = {
			showMore: false,
			filter: '',
			activePage: 1,
			itemsPerPage: 5,
			startIndex: 0,
			endIndex: 5
		};
		this.onPaginate = this.onPaginate.bind(this);
		this.onShowMore = this.onShowMore.bind(this);
		this.onFilter = this.onFilter.bind(this);
	}
	onPaginate({ activePage, startIndex, endIndex }) {
		this.setState({ activePage, startIndex, endIndex });
	}
	onShowMore(e) {
		e.preventDefault();
		const { showMore } = this.state;
		this.setState({ showMore: !showMore });
	}
	onFilter(e) {
		e.preventDefault();
		this.setState({ filter: e.target.value });
	}
	
	render() {
		const { policy } = this.props;
		const { showMore, filter, itemsPerPage, startIndex, endIndex } = this.state;

		if (!policy) return null;
		const decLength = policy.declarations ? policy.declarations.length : 0;
		const cardLength = policy.cards ? policy.cards.length : 0;
		const length = Math.max(decLength, cardLength);

		const cards = [];
		for (let index = 0; index < length; index++) {
			let dec, card;
			dec = index < decLength ? policy.declarations[index] : null;
			card = index < cardLength ? policy.cards[index] : null;
			cards.push({ dec, card });
		}
		const filteredDocs =
			filter.length === 0
				? policy.documents.filter(d => d.formNumber !== "ENOT-RCVDPYMT" && d.formNumber !== "ENOT-REMIND") //ENOT-RCVDPYMT & ENOT-REMIND is showing broken form so thats why hiding from documents sections
				: policy.documents.filter(
						d =>
						d.formNumber !== "ENOT-RCVDPYMT" && d.formNumber !== "ENOT-REMIND" && ((d.description || '').toLowerCase().includes((filter || '').toLowerCase()) ||
							moment(d.printDate)
								.format('MM/DD/YYYY')
								.toLowerCase()
								.includes((filter || '').toLowerCase()) ||
							(d.formNumber || '').toLowerCase().includes((filter || '').toLowerCase()))
				);
		const [firstCard, ...moreCards] = cards.map((c, i) => (
			<Table.Row key={i}>
				<Table.Cell>
					{c.dec ? (
						<a href={printUrl(c.dec.printUrl)} target='_blank' rel='noopener noreferrer'>
							{moment(c.dec.printDate).format('MM/DD/YYYY')}
						</a>
					) : null}
				</Table.Cell>
			</Table.Row>
		));
		const page = filteredDocs.slice(startIndex, endIndex);
		return (
			<div className='documents'>
				<Table celled unstackable>
					<Table.Header>
						<Table.Row>
							<Table.HeaderCell>Policy Declarations</Table.HeaderCell>
						</Table.Row>
					</Table.Header>
					<Table.Body>
						{firstCard}
						{showMore && moreCards.length > 0 ? moreCards : null}
					</Table.Body>
					{moreCards.length > 0 ? (
						<Table.Footer>
							<Table.Row>
								<Table.HeaderCell colSpan='2' className='filter'>
									<a href='/#' onClick={this.onShowMore}>
										{!showMore ? 'more' : 'less'}
									</a>
								</Table.HeaderCell>
							</Table.Row>
						</Table.Footer>
					) : null}
				</Table>
				<Table celled unstackable>
					<Table.Header>
						<Table.Row>
							<Table.HeaderCell colSpan='2'>Policy Forms</Table.HeaderCell>
							<Table.HeaderCell className='filter'>
								<Input placeholder='Filter...' onChange={this.onFilter} />
							</Table.HeaderCell>
						</Table.Row>
						<Table.Row>
							<Table.HeaderCell>Date</Table.HeaderCell>
							<Table.HeaderCell>Form</Table.HeaderCell>
							<Table.HeaderCell>Description</Table.HeaderCell>
						</Table.Row>
					</Table.Header>
					<Table.Body>
						{page
							? page.map((d, i) => (
									<Table.Row key={i}>
										<Table.Cell width={2}>{moment(d.printDate).format('MM/DD/YYYY')}</Table.Cell>
										<Table.Cell width={2}>{d.formNumber}</Table.Cell>
										<Table.Cell width={12}>
											<a href={printUrl(d.printUrl)} target='_blank' rel='noopener noreferrer'>
												{d.description}
											</a>
										</Table.Cell>
									</Table.Row>
							  ))
							: null}
					</Table.Body>
					<Table.Footer>
						<Table.Row>
							<Table.HeaderCell colSpan='3'>
								<Pagination activePage={this.state.activePage} itemsPerPage={itemsPerPage} totalItems={filteredDocs.length} pageRangeDisplayed={5} onPaginate={this.onPaginate} />
							</Table.HeaderCell>
						</Table.Row>
					</Table.Footer>
				</Table>
			</div>
		);
	}
}

PolicyDocuments.propTypes = {
	policy: PropTypes.object.isRequired
};

export default PolicyDocuments;
